<template>
  <div class="bookmark-form" :class="{completed: bookmarkCreated}">
    <span class="completion-icon"></span>

    <div class="form-content">
      <h4>Sla op bij jouw favorieten:</h4>
      <input type="text" v-model="newBookmark.bookmark_name" placeholder="Kies een naam...">
      <button @click="saveTask">
        Opslaan
      </button>

      <span
          class='error'
          v-if='errorMessage'
      >
        {{ errorMessage }}
      </span>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "CreateBookmarkForm",
  props: [
    "book_id",
    "page_number",
  ],
  data() {
    return {
      errorMessage: "",
      bookmarkCreated: false,
      newBookmark: {
        book_id: this.book_id,
        bookmark_name: "",
        page_number: this.page_number,
      },
    };
  },
  watch: {
    page_number() {
      this.newBookmark.page_number = this.page_number;
    },
    book_id() {
      this.newBookmark.book_id = this.book_id;
    },
  },
  methods: {
    ...mapActions("bookmark", [
      "createBookmark",
    ]),
    saveTask(e) {
      e.preventDefault();
      this.errorMessage = "";

      if (this.newBookmark.bookmark_name.length > 0) {
        this.createBookmark(this.newBookmark).then(() => {
          this.bookmarkCreated = true;
          setTimeout(() => {
            this.$emit("created");
          }, 1700);

          setTimeout(() => {
            this.bookmarkCreated = false;
            this.newBookmark.bookmark_name = '';
          }, 2000)
        });
      } else {
        this.errorMessage = "Vul alle velden in";
      }
    },
  },
};
</script>
